import { Component } from '@angular/core';
import { IonicPage, NavController, AlertController, ToastController } from 'ionic-angular';

import { TabsPage } from "../../pages/tabs/tabs";
import { DataProvider } from "../../providers/data/data";
import { LoadingController } from "ionic-angular";

@IonicPage()
@Component({
	selector: 'page-login',
	templateUrl: 'login.html',
})
export class LoginPage {
	credential: { email: String, password: String, hashed: boolean } = { email: null, password: null, hashed: false };

	constructor(
		public navCtrl: NavController,
		public alertCtrl: AlertController,
		public dataProvider: DataProvider,
		public loadCtrl: LoadingController,
		public toastCtrl: ToastController) {
	}

	ionViewDidEnter() {
		this.initializeCredSetting();
	}

	doLogin() {
		if (this.credential.email === null) {
			this.doToastMessage("FORMAT ERROR - Check your email and/or password format and re-try", 3000);

			this.doClear();
			return false;
		}

		if (this.credential.password === null) {
			this.doToastMessage("FORMAT ERROR - Check your email and/or password format and re-try", 3000);

			this.doClear();
			return false;
		}

		let loader = this.loadCtrl.create({ content: "Loading..." });
		loader.present();

		this.dataProvider.authPost(this.credential).
			then(function (a) {
				if (a.ok && a.status) {
					sessionStorage.setItem("__jwt__", a.headers.get("Authorization"));
					return a.json();
				}
				else if (a.status == 401) {
					this.doTransientMessage("UN-AUTHORIZED!");
				}
				else if (a.status == 500) {
					this.doTransientMessage("SERVER-ERROR");
				}
				else if (a.status == 415) {
					this.doTransientMessage("UNSUPPORTED MEDIA TYPE - CHECK REQUEST HEADERS");
				}
			}).
			then(res => {
				if (res != undefined) {
					sessionStorage.setItem("__aid__", res.Aid);
					sessionStorage.setItem("__uid__", res.Uid);

					this.doClear();
//					this.events.publish("login:init:date", new Date().toISOString());
					this.navCtrl.push(TabsPage, {date: new Date()});
				}

				loader.dismiss();
			}).
			catch(e => {
				console.dir(e);
				this.doAlertMessage("ERROR OCCURRED", "Check Email/Password");
				this.doClear();
				loader.dismiss();
			});

		this.doClear();
	};

	doRegister() {
		this.doAlertMessage("REGISTRATION", "Registering...");
		this.doToastMessage("RESISTRATION", 2500);
	};

	doClear() {
		this.credential.email = null;
		this.credential.password = null;
		this.credential.hashed = false;
	};

	doAlertMessage(title, subTitle) {
		let alert = this.alertCtrl.create({
			title: title || "ERROR OCCURRED!",
			subTitle: subTitle || null,
			buttons: ["OK"]
		});

		alert.present();
	};

	doToastMessage(message, duration) {
		let toast = this.toastCtrl.create({
			message: message,
			duration: duration || 3000
		});

		toast.present();
	};

	initializeCredSetting() {
		let crdLocalStorage = localStorage.getItem("__crd__");

		if (crdLocalStorage != null) {
			let crdLocalStorageParsed = JSON.parse(crdLocalStorage);
			this.credential.email = crdLocalStorageParsed.email;
			this.credential.password = crdLocalStorageParsed.password;
			this.credential.hashed = true;
		}
	};
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts